module.exports = __webpack_public_path__ + "static/media/backgroundimage.8be9c91d.png";